const cityImagesSrc =
  "https://creative.cdn.apm.any-digital.com/h5/findpoketcgstore/city-landmark-map";

const imagesList = [
  { src: `${cityImagesSrc}/Tokyo.webp`, nation: "Japan", prefecture: "Tokyo" },
  { src: `${cityImagesSrc}/Osaka.webp`, nation: "Japan", prefecture: "Osaka" },
  {
    src: `${cityImagesSrc}/Nagoya.webp`,
    nation: "Japan",
    prefecture: "Nagoya",
  },
  {
    src: `${cityImagesSrc}/Fukuoka.webp`,
    nation: "Japan",
    prefecture: "Fukuoka",
  },
  {
    src: `${cityImagesSrc}/Okinawa.webp`,
    nation: "Japan",
    prefecture: "Okinawa",
  },
  {
    src: `${cityImagesSrc}/Hong Kong.webp`,
    nation: "Hong Kong",
    prefecture: "Hong Kong",
  },
  {
    src: `${cityImagesSrc}/Taiwan.webp`,
    nation: "Taiwan",
    prefecture: "Taiwan",
  },
  {
    src: `${cityImagesSrc}/Seoul.webp`,
    nation: "South Korea",
    prefecture: "Seoul",
  },
  {
    src: `${cityImagesSrc}/Busan.webp`,
    nation: "South Korea",
    prefecture: "Busan",
  },
  {
    src: `${cityImagesSrc}/Bangkok.webp`,
    nation: "Tailand",
    prefecture: "Bangkok",
  },
  {
    src: `${cityImagesSrc}/Chiang Mai.webp`,
    nation: "Tailand",
    prefecture: "Chiang Mai",
  },
  {
    src: `${cityImagesSrc}/Singapore.webp`,
    nation: "Singapore",
    prefecture: "Singapore",
  },
  {
    src: `${cityImagesSrc}/Kuala Lumpur.webp`,
    nation: "Malaysia",
    prefecture: "Kuala Lumpur",
  },
  {
    src: `${cityImagesSrc}/Malaysia.webp`,
    nation: "Malaysia",
    prefecture: "Malaysia",
  },
  {
    src: `${cityImagesSrc}/Sydney.webp`,
    nation: "Australia",
    prefecture: "Sydney",
  },
];

export { cityImagesSrc, imagesList };
